<template>
  <div class="modal topup-modal payouts-modal">
    <div class="overlay" @click="$parent.closeWithdraw" />
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img
              src="./../image/close.svg"
              class="close"
              @click="$parent.closeWithdraw"
            />
            <div class="form-fields">
              <ValidationObserver
                ref="form"
                v-slot="{ handleSubmit, touched, valid }"
                slim
              >
                <div class="form-fields-wrapper">
                  <div class="cart-up">
                    <div class="cart-top">
                      <div class="title">
                        <b>{{ $t("WITHDRAW") }}</b>
                      </div>
                    </div>
                    <div class="topup-form">
                      <template v-if="step === 2">
                        <ValidationProvider
                          v-slot="{ errors }"
                          rules="required"
                          vid="amount"
                          name="amount"
                          slim
                        >
                          <label class="input-container">
                            <div class="desc">
                              {{ $t("Amount") }}
                            </div>
                            <input
                              v-model="amount"
                              type="text"
                              required
                              :placeholder="$t('Amount')"
                            />
                            <div class="desc desc-currency" v-if="selectedCurr">
                              {{
                                selectedCurr.symbol
                                  ? selectedCurr.symbol
                                  : selectedCurr.code
                              }}
                            </div>
                            <span v-if="errors && errors.length" class="error"
                              >{{ $t(errors[0]) }}
                            </span>
                          </label>
                        </ValidationProvider>
                        <label class="input-container">
                          <div class="desc">
                            {{ $t("Currency") }}
                          </div>
                          <select v-if="currencies" v-model="selectedCurr">
                            <option
                              v-for="item in currencies"
                              :value="item"
                              :key="item.code"
                            >
                              {{ item.code }}
                            </option>
                          </select>
                        </label>
                        <div class="desc" v-if="availableSum && selectedCurr">
                          {{ $t("Available for withdraw") }}:
                          {{ availableSum }}
                          {{
                            selectedCurr.symbol
                              ? selectedCurr.symbol
                              : selectedCurr.code
                          }}
                        </div>
                      </template>

                      <template v-if="step === 3">
                        <ValidationProvider
                          v-slot="{ errors }"
                          :rules="{
                            required: true,
                            regex: /^\d{4}\s\d{4}\s\d{4}\s\d{4}$/,
                          }"
                          vid="pan"
                          name="Card number"
                          slim
                        >
                          <label class="input-container">
                            <div class="desc">
                              {{ $t("Card number") }}
                            </div>
                            <input
                              v-model="formattedPan"
                              type="text"
                              required
                              :placeholder="$t('Card number')"
                              @input="
                                formattedPan = formatCardNumber(
                                  $event.target.value
                                );
                                resetErrorOnCardNumberChange();
                              "
                            />
                            <span v-if="errors && errors.length" class="error"
                              >{{ $t(errors[0]) }}
                            </span>
                          </label>
                        </ValidationProvider>

                        <ValidationProvider
                          v-slot="{ errors }"
                          :rules="{ required: true, regex: /^\d{2}\/\d{2}$/ }"
                          vid="expiration_date"
                          name="Expiration Date"
                          slim
                        >
                          <label class="input-container">
                            <div class="desc">
                              {{ $t("Expiration Date") }} (MM/YY)
                            </div>
                            <input
                              v-model="expiration_date"
                              type="text"
                              required
                              :placeholder="$t('Expiration Date') + '(MM/YY)'"
                              @input="
                                expiration_date = formatExpirationDate(
                                  $event.target.value
                                );
                                resetErrorOnExpirationDateChange();
                              "
                            />
                            <span v-if="errors && errors.length" class="error"
                              >{{ $t(errors[0]) }}
                            </span>
                          </label>
                        </ValidationProvider>

                        <ValidationProvider
                          v-slot="{ errors }"
                          :rules="{
                            required: true,
                            regex: /^[A-Za-z]+\s[A-Za-z]+$/,
                          }"
                          vid="card_holdername"
                          name="Card Holder Name"
                          slim
                        >
                          <label class="input-container">
                            <div class="desc">
                              {{ $t("Card Holder Name") }}
                            </div>
                            <input
                              v-model="card_holdername"
                              type="text"
                              required
                              :placeholder="$t('Card Holder Name')"
                              @input="
                                card_holdername = formatCardHolderName(
                                  $event.target.value
                                )
                              "
                            />
                            <span v-if="errors && errors.length" class="error"
                              >{{ $t(errors[0]) }}
                            </span>
                          </label>
                        </ValidationProvider>

                        <ValidationProvider
                          :rules="{ required: { allowFalse: false } }"
                          vid="terms"
                          slim
                        >
                          <div class="cta-container">
                            <div class="chekbox-container">
                              <label class="chekbox-label">
                                <div class="chekbox-label-wrapper">
                                  <input
                                    v-model="terms"
                                    type="checkbox"
                                    name="terms"
                                  />
                                  <div class="checkbox" />
                                  <span class="title">{{
                                    $t("I agree with")
                                  }}</span>
                                  <a
                                    class="title link"
                                    @click="$parent.goToPage('privacy')"
                                  >
                                    {{ $t("privacy policy") }}</a
                                  >
                                  <span class="title"> {{ $t("and") }} </span>
                                  <a
                                    class="title link"
                                    @click="$parent.goToPage('terms')"
                                  >
                                    {{ $t("terms and conditions") }}</a
                                  >
                                </div>
                              </label>
                            </div>
                          </div>
                        </ValidationProvider>
                      </template>
                    </div>
                  </div>
                  <div class="cart-bottom">
                    <button
                      :disabled="!valid"
                      :class="['button blue', { disabled: !valid }]"
                      @click="proceed"
                    >
                      <span> {{ $t("Withdraw") }}</span>
                    </button>
                  </div>
                  <div class="desc desc-secure">
                    {{
                      $t(
                        "We are using 3D secure methods to protect transactions"
                      )
                    }}
                  </div>

                  <transition name="slide">
                    <div v-if="success" class="error-desc desc green">
                      {{ $t(success) }}
                    </div>
                  </transition>
                  <transition name="slide">
                    <div v-if="$parent.error" class="error-desc desc red">
                      {{ $t($parent.error) }}
                    </div>
                  </transition>
                </div>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
// import axios from "axios";

export default {
  name: "PayoutModal",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: [],
  data: function () {
    return {
      step: 2,
      amount: 10,
      method: "card",
      pan: "",
      formattedPan: "", // Formatted value
      expiration_date: "", // Expiration date (MM/YY)
      card_holdername: "", // Card holder name
      first_name: "",
      last_name: "",
      phone: "",
      country: "",
      selectedCountry: "",
      countryId: "",
      city: "",
      address: "",
      zip: "",
      countryOptions: [],
      countryOptionsId: [],
      countries: [],
      terms: false,
      success: "",
      availableSum: "",
      currencies: [],
      curr: {},
      selectedCurr: {},
    };
  },
  computed: {
    requiredRegisterFieldsAreFilled() {
      let fieldsAreFilled;
      if (this.terms) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    },
  },
  mounted() {
    this.getCurrencies();
    this.getCounties();
  },

  watch: {
    selectedCurr: {
      handler() {
        this.getProfile();
      },
    },
  },
  methods: {
    getProfile() {
      this.$http
        .get(
          process.env.VUE_APP_API +
            "user/profile?currency=" +
            this.selectedCurr.code
        )
        .then((res) => {
          this.availableSum = res.data.balance_fiat;
          this.phone = res.data.phone;
          this.first_name = res.data.name;
          this.last_name = res.data.surname;
          this.countryId = res.data.country;
          this.city = res.data.city;
          this.address = res.data.address;
          this.zip = res.data.zip;

          if (this.countries && this.countries.length && this.countryId) {
            this.setCountry();
          }
          
          // Check if required fields are missing
          this.checkRequiredProfileData();
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          }
        });
    },
    checkRequiredProfileData() {
      // Check if user has filled required profile data for Chasse
      const missingFields = [];
      
      if (!this.address || this.address === 'N/A') {
        missingFields.push('address');
      }
      if (!this.city) {
        missingFields.push('city');
      }
      if (!this.countryId) {
        missingFields.push('country');
      }
      if (!this.zip) {
        missingFields.push('postal code');
      }
      
      if (missingFields.length > 0) {
        this.$parent.error = 
          'Please complete your profile first. Missing: ' + 
          missingFields.join(', ') + 
          '. Go to Profile → Settings to update.';
      }
    },
    getCurrencies() {
      this.$http.get(process.env.VUE_APP_API + "currencies").then((res) => {
        this.currencies = res.data.payload;
        this.curr = res.data.payload[0];
        this.selectedCurr = res.data.payload[0];
        this.getProfile();
      });
    },
    getCounties() {
      this.$http
        .get(process.env.VUE_APP_API + "countries")
        .then((res) => {
          let arr = res.data.payload;
          let newCountries = arr.map(function (item) {
            return item["title"];
          });
          let newCountriesId = arr.map(function (item) {
            return item["id"];
          });
          this.countryOptionsId = newCountriesId;
          this.countryOptions = newCountries;
          this.countries = arr;
          let mapped = this.countries.map(({ id, title, iso }) => ({
            id,
            title,
            iso,
          }));
          this.countries = mapped;

          if (this.countries && this.countries.length && this.countryId) {
            this.setCountry();
          }
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          }
        });
    },
    async proceed() {
      // Step 2: Amount entry -> go to step 3 (card details)
      if (this.step === 2) {
        const amount = parseFloat(this.amount);
        
        if (amount < 10) {
          this.$parent.error = "Minimum withdrawal amount is 10 " + this.selectedCurr.code;
          return;
        }
        
        if (amount > this.availableSum) {
          this.$parent.error = "Insufficient balance. Available: " + this.availableSum + " " + this.selectedCurr.code;
          return;
        }
        
        this.step = 3;
        this.$parent.error = "";
        return;
      }
      
      // Step 3: Card details -> submit withdrawal
      if (this.step === 3) {
        if (!this.terms) {
          this.$parent.error = "Please accept terms and conditions";
          return;
        }
        
        try {
          // Validate required profile data before proceeding
          if (!this.address || !this.city || !this.countryId || !this.zip) {
            this.$parent.error = "Please complete your profile before withdrawing";
            return;
          }
          
          // Parse expiration date MM/YY
          const [month, year] = this.expiration_date.split("/");
          
          // Get country ISO code from countries list
          const countryObj = this.countries.find(c => c.id == this.countryId);
          const countryCode = countryObj ? countryObj.iso : 'UA';
          
          const data = {
            amount: parseFloat(this.amount),
            currency: this.selectedCurr.code,
            card_number: this.formattedPan.replace(/\s/g, ""),
            expiry_month: month,
            expiry_year: year,
            cardholder_name: this.card_holdername,
            // Send profile data for Chasse receiverInfo
            address: this.address + ', ' + this.city + ', ' + this.zip,
            country: countryCode,
            birth_date: '2000-01-01', // TODO: Add birthdate to user profile if needed
          };
          
          const res = await this.$http.post(
            process.env.VUE_APP_API + `payouts`,
            data
          );
          
          if (res.data.status == "OK") {
            this.success = "Withdrawal initiated successfully!";
            this.$parent.error = "";
            
            // Update balance
            this.$parent.getBalance();
            
            // Close modal after 2 seconds
            setTimeout(() => {
              this.$parent.closeWithdraw();
            }, 2000);
          } else {
            this.$parent.error = res.data.message;
          }
        } catch (error) {
          this.$parent.error = error.response?.data?.message || "Failed to process withdrawal";
        }
      }
    },
    formatCardHolderName(value) {
      // Удаляем все символы, кроме букв и пробелов
      value = value.replace(/[^A-Za-z\s]/g, "");

      // Удаляем лишние пробелы, оставляем только один пробел между словами
      value = value.replace(/\s+/g, " ");

      // Ограничиваем количество слов до двух
      const words = value.split(" ");
      if (words.length > 2) {
        value = words.slice(0, 2).join(" ");
      }

      return value.toUpperCase();
    },
    formatExpirationDate(value) {
      // Remove non-digit characters
      value = value.replace(/\D/g, "");

      // Limit to 4 digits (MMYY)
      if (value.length > 4) {
        value = value.slice(0, 4);
      }

      // Add a slash after the first two digits (MM/YY)
      if (value.length > 2) {
        value = value.slice(0, 2) + "/" + value.slice(2);
      }

      // Ensure valid month (01-12)
      const [month] = value.split("/");
      if (month && parseInt(month, 10) > 12) {
        value = "12" + value.slice(2);
      }

      return value;
    },
    resetErrorOnExpirationDateChange() {
      this.$parent.error = ""; // Сбрасываем ошибку
    },
    resetErrorOnCardNumberChange() {
      this.$parent.error = ""; // Сбрасываем ошибку
    },
    formatCardNumber(value) {
      // Remove non-digit characters
      value = value.replace(/\D/g, "");

      // If the input length exceeds 16, truncate it
      if (value.length > 16) {
        return value.slice(0, 16).replace(/(\d{4})(?=\d)/g, "$1 "); // Keep only the first 16 digits
      }

      // Add spaces every 4 digits
      return value.replace(/(\d{4})(?=\d)/g, "$1 ");
    },
  },
};
</script>
